function assertInteger(n: number) {
  if (!Number.isInteger(n)) {
    throw new TypeError(`input must be integer, received ${n} instead.`)
  }
}

function majorScale(n: number) {
  assertInteger(n)

  return n * 8
}

function minorScale(n: number) {
  assertInteger(n)

  return n * 4
}

export default {
  majorScale,
  minorScale,
}
